import { Skeleton } from "@/components/atoms";
import { usePricingProfileContext, useStateRatesContext } from "@/components/organisms";
import { StateRatesEditPanel } from "@/components/organisms/TripCostV2/ContractPricingProfiles/StateRates/StateRatesEditPanel";
import { Restricted } from "@/components/pages/Restricted/Restricted";

export const StateRatesEdit = () => {
  const { isFetching: isFetchingPricingProfile, isRestricted: isRestrictedPricingProfile, pricingProfile } = usePricingProfileContext();
  const { isFetching: isFetchingStateRates, isRestricted: isRestrictedStateRates, activeState: state } = useStateRatesContext();
  const isFetching = isFetchingPricingProfile || isFetchingStateRates;
  const isRestricted = isRestrictedPricingProfile || isRestrictedStateRates;

  if (isFetching) {
    return (
      <div className="flex flex-1 flex-col min-h-[calc(100vh-120px)] px-5 py-4">
        <Skeleton />
      </div>
    );
  }

  return (
    <div className="flex flex-1 flex-col min-h-[calc(100vh-120px)] px-5 py-4">
      {isRestricted ? <Restricted /> : ((state && pricingProfile) && <StateRatesEditPanel state={state} pricingProfile={pricingProfile} />)}
    </div>
  );
};